import e from "react";
var t,
  n = {
    exports: {}
  },
  r = {
    exports: {}
  },
  o = {};
var i,
  a,
  u,
  l,
  s,
  c,
  f,
  d,
  p,
  m,
  v,
  y,
  g,
  h,
  w = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function b() {
  return a || (a = 1, "production" === process.env.NODE_ENV ? r.exports = function () {
    if (t) return o;
    t = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      i = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      u = e ? Symbol.for("react.profiler") : 60114,
      l = e ? Symbol.for("react.provider") : 60109,
      s = e ? Symbol.for("react.context") : 60110,
      c = e ? Symbol.for("react.async_mode") : 60111,
      f = e ? Symbol.for("react.concurrent_mode") : 60111,
      d = e ? Symbol.for("react.forward_ref") : 60112,
      p = e ? Symbol.for("react.suspense") : 60113,
      m = e ? Symbol.for("react.suspense_list") : 60120,
      v = e ? Symbol.for("react.memo") : 60115,
      y = e ? Symbol.for("react.lazy") : 60116,
      g = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      w = e ? Symbol.for("react.responder") : 60118,
      b = e ? Symbol.for("react.scope") : 60119;
    function C(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch (t) {
          case n:
            switch (e = e.type) {
              case c:
              case f:
              case i:
              case u:
              case a:
              case p:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case d:
                  case y:
                  case v:
                  case l:
                    return e;
                  default:
                    return t;
                }
            }
          case r:
            return t;
        }
      }
    }
    function L(e) {
      return C(e) === f;
    }
    return o.AsyncMode = c, o.ConcurrentMode = f, o.ContextConsumer = s, o.ContextProvider = l, o.Element = n, o.ForwardRef = d, o.Fragment = i, o.Lazy = y, o.Memo = v, o.Portal = r, o.Profiler = u, o.StrictMode = a, o.Suspense = p, o.isAsyncMode = function (e) {
      return L(e) || C(e) === c;
    }, o.isConcurrentMode = L, o.isContextConsumer = function (e) {
      return C(e) === s;
    }, o.isContextProvider = function (e) {
      return C(e) === l;
    }, o.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, o.isForwardRef = function (e) {
      return C(e) === d;
    }, o.isFragment = function (e) {
      return C(e) === i;
    }, o.isLazy = function (e) {
      return C(e) === y;
    }, o.isMemo = function (e) {
      return C(e) === v;
    }, o.isPortal = function (e) {
      return C(e) === r;
    }, o.isProfiler = function (e) {
      return C(e) === u;
    }, o.isStrictMode = function (e) {
      return C(e) === a;
    }, o.isSuspense = function (e) {
      return C(e) === p;
    }, o.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === f || e === u || e === a || e === p || e === m || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === v || e.$$typeof === l || e.$$typeof === s || e.$$typeof === d || e.$$typeof === h || e.$$typeof === w || e.$$typeof === b || e.$$typeof === g);
    }, o.typeOf = C, o;
  }() : r.exports = (i || (i = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      i = e ? Symbol.for("react.profiler") : 60114,
      a = e ? Symbol.for("react.provider") : 60109,
      u = e ? Symbol.for("react.context") : 60110,
      l = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      f = e ? Symbol.for("react.suspense") : 60113,
      d = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      m = e ? Symbol.for("react.lazy") : 60116,
      v = e ? Symbol.for("react.block") : 60121,
      y = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      h = e ? Symbol.for("react.scope") : 60119;
    function b(e) {
      if ("object" == typeof e && null !== e) {
        var d = e.$$typeof;
        switch (d) {
          case t:
            var v = e.type;
            switch (v) {
              case l:
              case s:
              case r:
              case i:
              case o:
              case f:
                return v;
              default:
                var y = v && v.$$typeof;
                switch (y) {
                  case u:
                  case c:
                  case m:
                  case p:
                  case a:
                    return y;
                  default:
                    return d;
                }
            }
          case n:
            return d;
        }
      }
    }
    var C = l,
      L = s,
      _ = u,
      k = a,
      x = t,
      B = c,
      S = r,
      E = m,
      O = p,
      j = n,
      T = i,
      $ = o,
      P = f,
      A = !1;
    function M(e) {
      return b(e) === s;
    }
    w.AsyncMode = C, w.ConcurrentMode = L, w.ContextConsumer = _, w.ContextProvider = k, w.Element = x, w.ForwardRef = B, w.Fragment = S, w.Lazy = E, w.Memo = O, w.Portal = j, w.Profiler = T, w.StrictMode = $, w.Suspense = P, w.isAsyncMode = function (e) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(e) || b(e) === l;
    }, w.isConcurrentMode = M, w.isContextConsumer = function (e) {
      return b(e) === u;
    }, w.isContextProvider = function (e) {
      return b(e) === a;
    }, w.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, w.isForwardRef = function (e) {
      return b(e) === c;
    }, w.isFragment = function (e) {
      return b(e) === r;
    }, w.isLazy = function (e) {
      return b(e) === m;
    }, w.isMemo = function (e) {
      return b(e) === p;
    }, w.isPortal = function (e) {
      return b(e) === n;
    }, w.isProfiler = function (e) {
      return b(e) === i;
    }, w.isStrictMode = function (e) {
      return b(e) === o;
    }, w.isSuspense = function (e) {
      return b(e) === f;
    }, w.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === s || e === i || e === o || e === f || e === d || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === p || e.$$typeof === a || e.$$typeof === u || e.$$typeof === c || e.$$typeof === y || e.$$typeof === g || e.$$typeof === h || e.$$typeof === v);
    }, w.typeOf = b;
  }()), w)), r.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function C() {
  if (l) return u;
  l = 1;
  var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable;
  return u = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (r, o) {
    for (var i, a, u = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(r), l = 1; l < arguments.length; l++) {
      for (var s in i = Object(arguments[l])) t.call(i, s) && (u[s] = i[s]);
      if (e) {
        a = e(i);
        for (var c = 0; c < a.length; c++) n.call(i, a[c]) && (u[a[c]] = i[a[c]]);
      }
    }
    return u;
  }, u;
}
function L() {
  if (c) return s;
  c = 1;
  return s = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function _() {
  return d ? f : (d = 1, f = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var k = b();
  n.exports = function () {
    if (y) return v;
    y = 1;
    var e = b(),
      t = C(),
      n = L(),
      r = _(),
      o = function () {
        if (m) return p;
        m = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var t = L(),
            n = {},
            r = _();
          e = function e(_e) {
            var t = "Warning: " + _e;
            "undefined" != typeof console && console.error(t);
            try {
              throw new Error(t);
            } catch (e) {}
          };
        }
        function o(o, i, a, u, l) {
          if ("production" !== process.env.NODE_ENV) for (var s in o) if (r(o, s)) {
            var c;
            try {
              if ("function" != typeof o[s]) {
                var f = Error((u || "React class") + ": " + a + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw f.name = "Invariant Violation", f;
              }
              c = o[s](i, s, u, a, null, t);
            } catch (e) {
              c = e;
            }
            if (!c || c instanceof Error || e((u || "React class") + ": type specification of " + a + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), c instanceof Error && !(c.message in n)) {
              n[c.message] = !0;
              var d = l ? l() : "";
              e("Failed " + a + " type: " + c.message + (null != d ? d : ""));
            }
          }
        }
        return o.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (n = {});
        }, p = o;
      }(),
      i = function i() {};
    function a() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (i = function i(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);
      try {
        throw new Error(t);
      } catch (e) {}
    }), v = function v(u, l) {
      var s = "function" == typeof Symbol && Symbol.iterator,
        c = "<<anonymous>>",
        f = {
          array: v("array"),
          bigint: v("bigint"),
          bool: v("boolean"),
          func: v("function"),
          number: v("number"),
          object: v("object"),
          string: v("string"),
          symbol: v("symbol"),
          any: m(a),
          arrayOf: function arrayOf(e) {
            return m(function (t, r, o, i, a) {
              if ("function" != typeof e) return new p("Property `" + a + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
              var u = t[r];
              if (!Array.isArray(u)) return new p("Invalid " + i + " `" + a + "` of type `" + h(u) + "` supplied to `" + o + "`, expected an array.");
              for (var l = 0; l < u.length; l++) {
                var s = e(u, l, o, i, a + "[" + l + "]", n);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          element: m(function (e, t, n, r, o) {
            var i = e[t];
            return u(i) ? null : new p("Invalid " + r + " `" + o + "` of type `" + h(i) + "` supplied to `" + n + "`, expected a single ReactElement.");
          }),
          elementType: m(function (t, n, r, o, i) {
            var a = t[n];
            return e.isValidElementType(a) ? null : new p("Invalid " + o + " `" + i + "` of type `" + h(a) + "` supplied to `" + r + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return m(function (t, n, r, o, i) {
              if (!(t[n] instanceof e)) {
                var a = e.name || c;
                return new p("Invalid " + o + " `" + i + "` of type `" + ((u = t[n]).constructor && u.constructor.name ? u.constructor.name : c) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
              }
              var u;
              return null;
            });
          },
          node: m(function (e, t, n, r, o) {
            return g(e[t]) ? null : new p("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return m(function (t, o, i, a, u) {
              if ("function" != typeof e) return new p("Property `" + u + "` of component `" + i + "` has invalid PropType notation inside objectOf.");
              var l = t[o],
                s = h(l);
              if ("object" !== s) return new p("Invalid " + a + " `" + u + "` of type `" + s + "` supplied to `" + i + "`, expected an object.");
              for (var c in l) if (r(l, c)) {
                var f = e(l, c, i, a, u + "." + c, n);
                if (f instanceof Error) return f;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? m(function (t, n, r, o, i) {
              for (var a = t[n], u = 0; u < e.length; u++) if (d(a, e[u])) return null;
              var l = JSON.stringify(e, function (e, t) {
                return "symbol" === w(t) ? String(t) : t;
              });
              return new p("Invalid " + o + " `" + i + "` of value `" + String(a) + "` supplied to `" + r + "`, expected one of " + l + ".");
            }) : ("production" !== process.env.NODE_ENV && i(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), a);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
            for (var t = 0; t < e.length; t++) {
              var o = e[t];
              if ("function" != typeof o) return i("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + b(o) + " at index " + t + "."), a;
            }
            return m(function (t, o, i, a, u) {
              for (var l = [], s = 0; s < e.length; s++) {
                var c = (0, e[s])(t, o, i, a, u, n);
                if (null == c) return null;
                c.data && r(c.data, "expectedType") && l.push(c.data.expectedType);
              }
              return new p("Invalid " + a + " `" + u + "` supplied to `" + i + "`" + (l.length > 0 ? ", expected one of type [" + l.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return m(function (t, r, o, i, a) {
              var u = t[r],
                l = h(u);
              if ("object" !== l) return new p("Invalid " + i + " `" + a + "` of type `" + l + "` supplied to `" + o + "`, expected `object`.");
              for (var s in e) {
                var c = e[s];
                if ("function" != typeof c) return y(o, i, a, s, w(c));
                var f = c(u, s, o, i, a + "." + s, n);
                if (f) return f;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return m(function (o, i, a, u, l) {
              var s = o[i],
                c = h(s);
              if ("object" !== c) return new p("Invalid " + u + " `" + l + "` of type `" + c + "` supplied to `" + a + "`, expected `object`.");
              var f = t({}, o[i], e);
              for (var d in f) {
                var m = e[d];
                if (r(e, d) && "function" != typeof m) return y(a, u, l, d, w(m));
                if (!m) return new p("Invalid " + u + " `" + l + "` key `" + d + "` supplied to `" + a + "`.\nBad object: " + JSON.stringify(o[i], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var v = m(s, d, a, u, l + "." + d, n);
                if (v) return v;
              }
              return null;
            });
          }
        };
      function d(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }
      function p(e, t) {
        this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
      }
      function m(e) {
        if ("production" !== process.env.NODE_ENV) var t = {},
          r = 0;
        function o(o, a, u, s, f, d, m) {
          if (s = s || c, d = d || u, m !== n) {
            if (l) {
              var v = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw v.name = "Invariant Violation", v;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var y = s + ":" + u;
              !t[y] && r < 3 && (i("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), t[y] = !0, r++);
            }
          }
          return null == a[u] ? o ? null === a[u] ? new p("The " + f + " `" + d + "` is marked as required in `" + s + "`, but its value is `null`.") : new p("The " + f + " `" + d + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(a, u, s, f, d);
        }
        var a = o.bind(null, !1);
        return a.isRequired = o.bind(null, !0), a;
      }
      function v(e) {
        return m(function (t, n, r, o, i, a) {
          var u = t[n];
          return h(u) !== e ? new p("Invalid " + o + " `" + i + "` of type `" + w(u) + "` supplied to `" + r + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function y(e, t, n, r, o) {
        return new p((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
      }
      function g(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(g);
            if (null === e || u(e)) return !0;
            var t = function (e) {
              var t = e && (s && e[s] || e["@@iterator"]);
              if ("function" == typeof t) return t;
            }(e);
            if (!t) return !1;
            var n,
              r = t.call(e);
            if (t !== e.entries) {
              for (; !(n = r.next()).done;) if (!g(n.value)) return !1;
            } else for (; !(n = r.next()).done;) {
              var o = n.value;
              if (o && !g(o[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function h(e) {
        var t = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }(t, e) ? "symbol" : t;
      }
      function w(e) {
        if (null == e) return "" + e;
        var t = h(e);
        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return t;
      }
      function b(e) {
        var t = w(e);
        switch (t) {
          case "array":
          case "object":
            return "an " + t;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;
          default:
            return t;
        }
      }
      return p.prototype = Error.prototype, f.checkPropTypes = o, f.resetWarningCache = o.resetWarningCache, f.PropTypes = f, f;
    }, v;
  }()(k.isElement, !0);
} else n.exports = function () {
  if (h) return g;
  h = 1;
  var e = L();
  function t() {}
  function n() {}
  return n.resetWarningCache = t, g = function g() {
    function r(t, n, r, o, i, a) {
      if (a !== e) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }
    function o() {
      return r;
    }
    r.isRequired = r;
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  };
}()();
var x = n.exports;
function B() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return t.filter(Boolean).join(" ");
}
var S = {
  button: "Button-module_button__18Bed",
  shadow: "Button-module_shadow__cwtDe",
  leftArrow: "Button-module_leftArrow__MIaEz",
  inverted: "Button-module_inverted__bGHmY",
  rightArrow: "Button-module_rightArrow__iam-1",
  favorite: "Button-module_favorite__ABC9q",
  selected: "Button-module_selected__8rUFd"
};
!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      o = document.createElement("style");
    o.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}('.Button-module_button__18Bed {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  border-radius: 4px;\n  cursor: pointer;\n  width: 35px;\n  height: 35px;\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.Button-module_shadow__cwtDe {\n  box-shadow: 0 3px 12px rgba(6, 25, 47, 0.5);\n}\n\n.Button-module_leftArrow__MIaEz {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_leftArrow__MIaEz.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_leftArrow__MIaEz:hover {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_leftArrow__MIaEz:hover.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n\n.Button-module_rightArrow__iam-1 {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_rightArrow__iam-1.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_rightArrow__iam-1:hover {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_rightArrow__iam-1:hover.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n\n.Button-module_favorite__ABC9q {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_favorite__ABC9q.Button-module_selected__8rUFd {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="%23005EB8"/></svg>\');\n}\n.Button-module_favorite__ABC9q.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_favorite__ABC9q.Button-module_selected__8rUFd.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="white"/></svg>\');\n}\n.Button-module_favorite__ABC9q:hover {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_favorite__ABC9q:hover.Button-module_selected__8rUFd {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="white"/></svg>\');\n}\n.Button-module_favorite__ABC9q:hover.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_favorite__ABC9q:hover.Button-module_selected__8rUFd.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="%23005EB8"/></svg>\');\n}');
var E = function E(t) {
  var n = t.onClick,
    r = t.icon,
    o = t.dropShadow,
    i = t.invertColors,
    a = t.selected,
    u = o ? S.shadow : "",
    l = i ? S.inverted : "",
    s = a ? S.selected : "";
  return e.createElement("button", {
    className: B(S.button, S[r], u, l, s),
    onClick: n
  });
};
E.propTypes = {
  onClick: x.PropTypes.function,
  icon: x.PropTypes.string.isRequired,
  dropShadow: x.PropTypes.bool,
  invertColors: x.PropTypes.bool,
  selected: x.PropTypes.bool
}, E.defaultProps = {
  dropShadow: !0
};
export { E as Button, E as default };